import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonShapes} from '@s-ui/react-atom-button'
import AtomIcon, {ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import {useSuiContext} from '@s-ui/react-context'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'

const BASE_CLASS_NAME = 'mt-form-publishAd-cardRecommendedPriceDrawer'

const IconCloseModal = () => (
  <AtomIcon as="button" size={ATOM_ICON_SIZES.medium}>
    <IconClose />
  </AtomIcon>
)

const DocumentationDrawerContent = ({onClose}) => {
  const {i18n} = useSuiContext()

  const items = [
    {
      title: i18n.t(`PUBLISH_AD.RECOMMENDED_PRICE.KNOW_MORE.USE_BRAND_NEW_PRICE.TITLE`),
      description: i18n.t(`PUBLISH_AD.RECOMMENDED_PRICE.KNOW_MORE.USE_BRAND_NEW_PRICE.DESCRIPTION`)
    },
    {
      title: i18n.t(`PUBLISH_AD.RECOMMENDED_PRICE.KNOW_MORE.CALCULATE_CURRENT_VALUE.TITLE`),
      description: i18n.t(`PUBLISH_AD.RECOMMENDED_PRICE.KNOW_MORE.CALCULATE_CURRENT_VALUE.DESCRIPTION`)
    },
    {
      title: i18n.t(`PUBLISH_AD.RECOMMENDED_PRICE.KNOW_MORE.COMPARE_WITH_SIMILAR_ADS.TITLE`),
      description: i18n.t(`PUBLISH_AD.RECOMMENDED_PRICE.KNOW_MORE.COMPARE_WITH_SIMILAR_ADS.DESCRIPTION`)
    },
    {
      title: i18n.t(`PUBLISH_AD.RECOMMENDED_PRICE.KNOW_MORE.WE_GET_RECOMMENDED_PRICE.TITLE`),
      description: i18n.t(`PUBLISH_AD.RECOMMENDED_PRICE.KNOW_MORE.WE_GET_RECOMMENDED_PRICE.DESCRIPTION`)
    }
  ]

  const handleClose = () => {
    onClose()
  }

  return (
    <>
      <div className={`${BASE_CLASS_NAME}CloseButton`}>
        <AtomButton
          design={atomButtonDesigns.FLAT}
          leftIcon={<IconCloseModal />}
          onClick={handleClose}
          shape={atomButtonShapes.CIRCULAR}
        />
      </div>

      <div className={BASE_CLASS_NAME}>
        <TitleBasic
          as={titleBasicTags.h3}
          size={titleBasicSizes.s}
          title={i18n.t(`PUBLISH_AD.RECOMMENDED_PRICE.KNOW_MORE.TITLE`)}
        />
        <ul className={`${BASE_CLASS_NAME}List`}>
          {items.map(({title, description}, index) => (
            <li key={index} className={`${BASE_CLASS_NAME}ListItem`}>
              <div aria-hidden className={`${BASE_CLASS_NAME}ListItemIcon`}>
                {index + 1}
              </div>
              <div className={`${BASE_CLASS_NAME}ListItemContent`}>
                <TitleBasic as={titleBasicTags.h4} size={titleBasicSizes.xs} title={title} />
                <p className={`${BASE_CLASS_NAME}ListItemDescription`}>{description}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </>
  )
}

DocumentationDrawerContent.propTypes = {
  onClose: PropTypes.func.isRequired
}

export default DocumentationDrawerContent
